import { render, staticRenderFns } from "./ListQuestion.vue?vue&type=template&id=feb2442a&scoped=true&"
import script from "./ListQuestion.vue?vue&type=script&lang=js&"
export * from "./ListQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ListQuestion.vue?vue&type=style&index=0&id=feb2442a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb2442a",
  null
  
)

export default component.exports